import type { RecipeMainIngredient } from '@apps/main/modules/recipe/ingredients';
import {
  isFlightIngredient,
  isFerryIngredient,
  isHotelIngredient,
  isOwnStayIngredient,
  isOwnTransportIngredient,
} from '@apps/main/modules/recipe/ingredients';

import {
  FLIGHT_INGREDIENT_SUFFIX,
  FlightSerializer,
  FERRY_INGREDIENT_SUFFIX,
  FerrySerializer,
} from './transportSerializer';
import {
  HOTEL_INGREDIENT_SUFFIX,
  HotelSerializer,
  OWN_STAY_INGREDIENT_SUFFIX,
  OwnStaySerializer,
} from './staySerializer';
import {
  OWN_TRANSPORT_INGREDIENT_SUFFIX,
  OwnTransportSerializer,
} from './ownTransportSerializer';

export interface IngredientSerializer<T> {
  serialize: (ingredient: T) => string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deserialize: (value: string, ...args: any[]) => T;
}

export const IngredientSerializer: IngredientSerializer<RecipeMainIngredient> =
  {
    serialize: function (ingredient: RecipeMainIngredient): string {
      if (isFlightIngredient(ingredient)) {
        return FlightSerializer.serialize(ingredient);
      }

      if (isFerryIngredient(ingredient)) {
        return FerrySerializer.serialize(ingredient);
      }

      if (isHotelIngredient(ingredient)) {
        return HotelSerializer.serialize(ingredient);
      }

      if (isOwnStayIngredient(ingredient)) {
        return OwnStaySerializer.serialize(ingredient);
      }

      if (isOwnTransportIngredient(ingredient)) {
        return OwnTransportSerializer.serialize(ingredient);
      }

      throw new Error('Invalid RecipeMainIngredient');
    },
    deserialize: function (
      value: string,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...args: any[]
    ): RecipeMainIngredient {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      const ingredientSufix = value.slice(-2);

      if (ingredientSufix === FLIGHT_INGREDIENT_SUFFIX) {
        return FlightSerializer.deserialize(value, ...args);
      }

      if (ingredientSufix === FERRY_INGREDIENT_SUFFIX) {
        return FerrySerializer.deserialize(value, ...args);
      }

      if (ingredientSufix === HOTEL_INGREDIENT_SUFFIX) {
        return HotelSerializer.deserialize(value, ...args);
      }

      if (ingredientSufix === OWN_STAY_INGREDIENT_SUFFIX) {
        return OwnStaySerializer.deserialize(value, ...args);
      }

      if (ingredientSufix === OWN_TRANSPORT_INGREDIENT_SUFFIX) {
        return OwnTransportSerializer.deserialize(value, ...args);
      }

      throw new Error(
        `Invalid serialized IngredientSuffix '${ingredientSufix}'`
      );
    },
  };
